import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/app/admin/_common/ui/table";

export default function UserListSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <Table
        containerClassName="min-h-0 flex-1 overflow-x-auto overflow-y-auto"
        className="min-w-[820px] table-fixed"
      >
        <TableHeader>
          <TableRow className="sticky top-0 z-10 hover:bg-muted [&>th]:bg-muted">
            <TableHead className="h-8 w-[30%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              User
            </TableHead>
            <TableHead className="h-8 w-[25%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Roles
            </TableHead>
            <TableHead className="h-8 w-[15%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Status
            </TableHead>
            <TableHead className="h-8 w-[18%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Last sign in
            </TableHead>
            <TableHead className="h-8 w-12 pr-6 text-right" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: 4 }).map((_, index) => (
            <TableRow key={index} className="hover:bg-transparent">
              <TableCell className="py-1.5">
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-44" />
                </div>
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-28" />
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-5 w-20 rounded-[7px]" />
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-24" />
              </TableCell>
              <TableCell className="w-12 py-1.5 pr-6 text-right">
                <Skeleton className="ml-auto size-6 rounded-md" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
